export default __webpack_public_path__ + "static/media/savedBookmark.f775ed75.svg";